<template>
  <header class="shopHeader">
    <transition name="fade">
      <span v-if="subtitle === ''" key="default">
        <!-- <a class="debug_image" href="" @click.prevent="handleClickDebug">
          &nbsp;&nbsp;&nbsp;&nbsp;
        </a> -->
        <a href="" @click.prevent="handleClickShopLogo">
          <img
            src="../../assets/images/logo_shop.png"
            height="23"
            :alt="name"
          />
        </a>

        <a href="" @click.prevent="handleClickShopName">{{ name }}</a>
      </span>
      <span class="txt_over_1" :key="subtitle" v-else>{{ subtitle }}</span>
    </transition>
    <div class="headerLeftBt">
      <transition name="fade">
        <button
          type="button"
          class="btPrev"
          v-if="isShowPrevButton === true"
          @click="handleClickBackButton"
        >
          <span class="icon iconPrev"></span>
          <span class="accessibilityHide">
            {{ $t('common.accessibility.previous') }}
          </span>
        </button>
      </transition>
    </div>
    <div class="headerRightBt">
      <transition name="fade">
        <button
          key="search"
          type="button"
          class="btSearch"
          v-if="buttonType === 'search'"
          @click="handleClickSearch"
        >
          <span class="icon iconSearch"></span>
          <span class="accessibilityHide">
            {{ $t('common.accessibility.search') }}
          </span>
        </button>
        <button
          key="cart"
          type="button"
          class="btCart"
          v-if="buttonType === 'cart' && enableCart"
          @click="handleClickCart"
        >
          <span class="icon iconCartHeader"></span>
          <span class="accessibilityHide">
            {{ $t('common.accessibility.cart') }}
          </span>
          <span class="num" v-if="cartUniqueQuantity">
            {{ cartUniqueQuantity }}
          </span>
        </button>
        <button
          key="home"
          type="button"
          class="btHome"
          v-if="buttonType === 'home'"
          @click="handleClickHome"
        >
          <span class="icon iconHomeHeader"></span>
          <span class="accessibilityHide">
            {{ $t('common.accessibility.home') }}
          </span>
        </button>
        <!-- <button type="button" class="btClose"><span class="icon iconClose"></span><span class="accessibilityHide">닫기</span></button> -->
      </transition>
    </div>
    <!-- <div class="debug_panel" v-if="showDebugPanel">
      NPP: {{ getNPPCookie() }}
      <br />
      _nest: {{ getNest() }}
      <br />
      ENC: {{ getENC() }}
      <br />
      ifwt: {{ getIfwt() }}
      <br />
    </div> -->
  </header>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { beforeSendLog, goToIntro } from '@/utils'
import EventBus from '@/utils/eventBus'
import Cookies from 'js-cookie'
import { getBaseInfo } from '@/utils'

export default {
  name: 'ShopHeader',
  data() {
    return {
      showDebugPanel: false,
      nationPath: 'kr'
    }
  },
  computed: {
    ...mapGetters('main', ['name', 'enableCart']),
    ...mapGetters('header', ['subtitle', 'buttonType', 'isShowPrevButton']),
    ...mapGetters('cart', ['cartUniqueQuantity'])
  },
  methods: {
    ...mapActions('search', ['openSearchForm']),
    handleClickCart() {
      beforeSendLog('NaviCart')
      this.$router.push('/cart')
    },
    handleClickSearch() {
      beforeSendLog('NaviSearch')
      this.openSearchForm()
    },
    handleClickShopLogo() {
      beforeSendLog('NaviShoplogo')

      if (this.nationPath === 'jp') {
        this.$router.push({ name: 'main' })
      } else {
        goToIntro()
      }
    },
    handleClickShopName() {
      beforeSendLog('NaviShopname')
      this.$router.push({ name: 'main' })
    },
    handleClickHome() {
      beforeSendLog('NaviHome')
      this.$router.push({ name: 'main' })
    },
    handleClickBackButton() {
      if (location.href.indexOf('characters') !== -1) {
        beforeSendLog('Out')
      }
      this.$router.go(-1)
      if (this.$router.currentRoute.name === 'order') {
        EventBus.$emit('changeUrl')
      }
    },
    handleClickDebug() {
      this.showDebugPanel = !this.showDebugPanel
    },
    getNPPCookie() {
      const cookies = Cookies.get('NPP')
      return cookies
    },
    getENC() {
      const cookies = Cookies.get('ENC')
      return cookies
    },
    getNest() {
      const cookies = Cookies.get('_nest')
      return cookies
    },
    getIfwt() {
      const cookies = Cookies.get('_ifwt')
      return cookies
    }
  },
  mounted() {
    const { nationPath } = getBaseInfo()
    this.nationPath = nationPath
  }
}
</script>

<style lang="scss" scoped>
.debug_panel {
  position: absolute;
  top: 200px;
  width: 500px;
  background-color: red;
  word-break: break-all;
}
.shopHeader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 55px;
  background-color: #fff;
  border-bottom: 1px solid #d6d6db;
  z-index: 100;
  > span {
    display: block;
  }
  > a,
  > span {
    position: absolute;
    left: 0;
    right: 0;
    padding: 20px 55px 0 55px;
    font-size: 18px;
    font-weight: bold;
    text-align: center;
    vertical-align: middle;

    &.fade-enter {
      opacity: 0;
      transform: translateY(20px);
    }
    &.fade-leave-to {
      opacity: 0;
      transform: translateY(-20px);
    }
  }
  img {
    margin: -5px 3px -5px 0;
  }
  .fade-enter-active {
    transition: all 0.5s cubic-bezier(0.19, 1, 0.22, 1);
  }
  .fade-leave-active {
    transition: all 0.4s cubic-bezier(0.19, 1, 0.22, 1);
  }

  .headerLeftBt .fade-enter,
  .headerLeftBt .fade-leave-to {
    opacity: 0;
    transform: translateX(-20px);
  }
  .headerRightBt .fade-enter,
  .headerRightBt .fade-leave-to {
    opacity: 0;
    transform: translateX(20px);
  }
}
.headerLeftBt,
.headerRightBt {
  position: absolute;
  top: 0;
  width: 55px;
  height: 55px;
  overflow: hidden;
  button {
    position: absolute;
    top: 0;
    width: 50px;
    height: 54px;
  }
  .btCart {
    .num {
      position: absolute;
      top: 10px;
      left: 50%;
      display: block;
      width: 16px;
      height: 16px;
      padding: 2px 0 0 0;
      color: #fff;
      font-size: 11px;
      text-align: center;
      border-radius: 8px;
      background-color: #e83333;
    }
  }
}
.headerLeftBt {
  left: 0;
  // margin-left: 0; safeArea
  button {
    left: 0;
  }
}
.headerRightBt {
  right: 0;
  // margin-right: 0; safeArea
  button {
    right: 0;
  }
}

@media screen and (min-width: 1024px) {
  .shopHeader {
    width: 1024px;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>
